export default __webpack_public_path__ + "static/media/pinterest.53baec3b.svg";